import {
	availableMultipleText,
	availableSingleText,
	backorderDateText,
	backorderHasDaysText,
	inStoreOnlyText,
	noBackorderText,
	noBackorderWithRestockText,
	notPurchasableText,
	noWebOrderingText,
	outOfStockText,
	preorderText,
	prereleaseText,
	specsOrderingStockNotifyClick,
	unavailableText,
} from '../store/orderingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { availableTextHasDays, availableTextHasPlus } from '../utilities/product_utilities';
import { getStockMessageData } from '../utilities/product_utilities';
import classNames from 'classnames';
import { replaceTextDelimeterWithText } from '../utilities/language_utilities';

//Internal Use Message Sub Components
function StockMessageNotifyLink({ notifyCode }) {
	const dispatch = useDispatch();
	return (
		<a
			className='notify_stock alert-link'
			href={'/notifystock.html?pcode=' + notifyCode}
			onClick={(e) => {
				e.preventDefault();
				dispatch(specsOrderingStockNotifyClick(notifyCode));
			}}
		>
			Email me when this item is in stock
		</a>
	);
}

function StockMessageUnavailable() {
	const unavailable_text = useSelector(unavailableText);
	return <>{unavailable_text}</>;
}

function StockMessageNoWebOrdering() {
	const no_webordering_text = useSelector(noWebOrderingText);
	return <>{no_webordering_text}</>;
}

function StockMessageNotPurchaseable() {
	const not_purchasable_text = useSelector(notPurchasableText);
	return <>{not_purchasable_text}</>;
}

function StockMessageInStoreOnly() {
	const in_store_only_text = useSelector(inStoreOnlyText);
	return <>{in_store_only_text}</>;
}

function StockMessagePreRelease({ availableText }) {
	const prerelease_text = useSelector(prereleaseText);
	return <>{replaceTextDelimeterWithText(prerelease_text, availableText)}</>;
}

function StockMessagePreOrder({ availableText, notifyStock = false, notifyCode = '' }) {
	const preorder_text = useSelector(preorderText);
	return (
		<>
			<>{replaceTextDelimeterWithText(preorder_text, availableText)}</>
			{notifyStock && notifyCode && (
				<>
					{' '}
					<StockMessageNotifyLink notifyCode={notifyCode} />.
				</>
			)}
		</>
	);
}

function StockMessageAvailable({ availableText }) {
	const is_singular = parseInt(availableText) === 1;
	const stock_message_text = useSelector(is_singular ? availableSingleText : availableMultipleText);
	return <>{replaceTextDelimeterWithText(stock_message_text, availableText)}</>;
}

function StockMessageNoBackorder({ availableText, notifyStock = false, notifyCode = '', showRestockDate = false }) {
	const no_backorder_text = useSelector(noBackorderText);
	const no_backorder_with_restock_text = useSelector(noBackorderWithRestockText)

	return (
		<>
			<>
				{showRestockDate && availableText && !availableTextHasDays(availableText) && !availableTextHasPlus(availableText) ? 
				replaceTextDelimeterWithText(no_backorder_with_restock_text, availableText)
				: no_backorder_text}
			</>
			{notifyStock && notifyCode && (
				<>
					<StockMessageNotifyLink notifyCode={notifyCode} />.
				</>
			)}
		</>
	);
}

function StockMessageOutOfStock() {
	const out_of_stock_text = useSelector(outOfStockText);
	return <>{out_of_stock_text}</>;
}

function StockMessageBackorder({ availableText, notifyStock = false, notifyCode = '' }) {
	const availableTextHasDaysBoolean = availableTextHasDays(availableText);
	const backorder_text = useSelector(availableTextHasDaysBoolean ? backorderHasDaysText : backorderDateText);

	if (availableTextHasDaysBoolean) {
		return <>{replaceTextDelimeterWithText(backorder_text, availableText)}</>;
	} else {
		if (availableText && !availableTextHasPlus(availableText)) {
			return (
				<>
					<>{replaceTextDelimeterWithText(backorder_text, availableText)} </>
					{notifyStock && notifyCode && (
						<>
							<StockMessageNotifyLink notifyCode={notifyCode} />.
						</>
					)}
				</>
			);
		}
	}
}

function StockMessageWrapper({ children, alertType = 'warning', messageStatus }) {
	const alert_class_names = classNames({
		alert: true,
		'alert-with-icon': true,
		'alert-danger': alertType === 'danger',
		'alert-warning': alertType === 'warning',
		'is-invalid': messageStatus === 'Invalid',
		'is-backordered': messageStatus === 'Backorder',
		'is-low-stock': messageStatus === 'LowStock',
	});

	const icon_class_names = classNames({
		icon: true,
		'alert-icon': true,
		'icon-backorder': messageStatus === 'Backorder',
		'icon-warning': alertType === 'warning',
		'icon-error': alertType === 'danger',
	});

	return (
		<div className={alert_class_names}>
			<span className={icon_class_names}></span>
			<div className='alert-body'>{children}</div>
		</div>
	);
}

export function SelectedStockMessage({ matches }) {
	const stock_message_data = getStockMessageData(matches);

	if (stock_message_data === null) {
		return <></>;
	}
	const valid_types = {
		Unavailable: StockMessageUnavailable,
		PreRelease: StockMessagePreRelease,
		NoWebOrdering: StockMessageNoWebOrdering,
		OutOfStock: StockMessageOutOfStock,
		NoBackorder: StockMessageNoBackorder,
		PreOrder: StockMessagePreOrder,
		Backorder: StockMessageBackorder,
		Available: StockMessageAvailable,
		NotPurchaseable: StockMessageNotPurchaseable,
		InStoreOnly: StockMessageInStoreOnly,
	};

	const danger_types = ['Unavailable', 'OutOfStock'];

	if (stock_message_data.messageType && typeof valid_types[stock_message_data.messageType] !== 'undefined') {
		const MessageComponent = valid_types[stock_message_data.messageType];
		const message_wrap_props = {};
		if (danger_types.indexOf(stock_message_data.messageType) !== -1) {
			message_wrap_props.alertType = 'danger';
		}
		if (stock_message_data.messageStatus) {
			message_wrap_props.messageStatus = stock_message_data.messageStatus;
		}
		return (
			<StockMessageWrapper {...message_wrap_props}>
				<MessageComponent {...stock_message_data} />
			</StockMessageWrapper>
		);
	} else {
		return <></>;
	}
}
